import { Modal } from 'react-bootstrap'

const ExpandTableTextModal = ({ show, onHide, text }) => {
    return (<Modal show={show} onHide={onHide} centered scrollable={true} size='lg'>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            <span>{text}</span>
        </Modal.Body>
        <Modal.Footer>
            <button className='btn-app-secondary' onClick={() => onHide()}>Zamknij</button>
        </Modal.Footer>
    </Modal>)
}

export default ExpandTableTextModal